/** 💰料金をアプリの公開APIから取得（⚙️で変更→サイト表示も自動連動）。失敗時は既定値 */
import { useEffect, useState } from 'react';
import { SITE_CONFIG, PRICING_API } from '../config';

export interface Pricing {
  base: string;
  project: string;
  user: string;
  baseN: number;
  projectN: number;
  userN: number;
}

const fmt = (n: number) => n.toLocaleString('ja-JP');

export function usePricing(): Pricing {
  const toN = (s: string) => Number(s.replace(/,/g, ''));
  const [p, setP] = useState<Pricing>({
    base: SITE_CONFIG.basePrice,
    project: SITE_CONFIG.projectPrice,
    user: SITE_CONFIG.userPrice,
    baseN: toN(SITE_CONFIG.basePrice),
    projectN: toN(SITE_CONFIG.projectPrice),
    userN: toN(SITE_CONFIG.userPrice),
  });
  useEffect(() => {
    let alive = true;
    fetch(PRICING_API)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        if (!alive || !j) return;
        if (
          typeof j.baseFeeYen === 'number' &&
          typeof j.projectFeeYen === 'number' &&
          typeof j.userFeeYen === 'number'
        ) {
          setP({
            base: fmt(j.baseFeeYen),
            project: fmt(j.projectFeeYen),
            user: fmt(j.userFeeYen),
            baseN: j.baseFeeYen,
            projectN: j.projectFeeYen,
            userN: j.userFeeYen,
          });
        }
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return p;
}
